import { Card, Nav } from "react-bootstrap";
import { t } from "i18next";
import styles from "./UserTabs.module.scss";

const UserTabs = ({ activeKey, showSecurity = false, showPermissions = false }) => {
    return (
        <Card className="mb-4">
            <Card.Body className="p-0">
                <Nav variant="tabs" activeKey={activeKey} className={styles.tabs}>
                    <Nav.Item>
                        <Nav.Link eventKey="profile">
                            {t("profile")}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="reports">
                            {t("report_preferences")}
                        </Nav.Link>
                    </Nav.Item>
                    {showPermissions && (
                        <Nav.Item>
                            <Nav.Link eventKey="permissions">
                                {t("permissions")}
                            </Nav.Link>
                        </Nav.Item>
                    )}


                    {showSecurity && (
                        <Nav.Item>
                            <Nav.Link eventKey="security">
                                {t("security")}
                            </Nav.Link>
                        </Nav.Item>
                    )}
                </Nav>
            </Card.Body>
        </Card>
    );
};

export default UserTabs;
